var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.verified)?_c('Verification',{on:{"is-auth":_vm.setVerified}}):_c('QuestionsEditor')
}
var staticRenderFns = []

export { render, staticRenderFns }